import { Divider } from '@mui/material';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import {
  SubscriptionBundles,
  SubscriptionBundlesProps,
} from '../subscription/view/SubscriptionBundles';
import { OtpBundles } from '../otp/view/OtpBundles';
import { OtpBundlesVMData } from '../otp/viewModel/otpBundles.viewModel';

export const BundlesView = ({
  subscriptionBundles,
  otpBundles,
}: {
  subscriptionBundles: SubscriptionBundlesProps;
  otpBundles: OtpBundlesVMData;
}) => {
  return (
    <div className="flex flex-col">
      <SubscriptionBundles {...subscriptionBundles} />
      {subscriptionBundles.hideSubscriptionBundles ? null : (
        <Divider className={clsx('mt-6 mb-4', sprinkles({ color: 'N-40' }))} />
      )}
      <OtpBundles {...otpBundles} />
    </div>
  );
};
